import { render, staticRenderFns } from "./InvestmentsPrefs.vue?vue&type=template&id=1ddbf31e&"
import script from "./InvestmentsPrefs.vue?vue&type=script&lang=js&"
export * from "./InvestmentsPrefs.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentsPrefs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports